























































import { Component, Vue } from 'vue-property-decorator';
import { ModalConstants } from '@/core/constants';
import { RealmApi } from '@/services/api/api.realms';
import ProgressBar from '@/components/ProgressBar.vue';
import { GitAPI } from '@/services/api/api.git';
import GitDiffHighlighter from '@/components/GitDiffHighlighter.vue';
import CommitChangesWindow from './CommitChangesWindow.vue';

@Component({
    components: { ProgressBar, GitDiffHighlighter, CommitChangesWindow }
})
export default class BuildProcessWindow extends Vue {
	id: string = ModalConstants.BuildProcessWindow;

    uncomittedChanges: string = '';

    buildStatusProcess: string = '';
    buildStatusPercent: number = 0;
    progressBarStatus: string = '';
    buildFinished: boolean = false;
    buildFinishedSuccessfully: boolean = false;
    hasRunBuild: boolean = false;
    interval!: any;

    buildInitiating: boolean = false;

    mode: 'build' | 'changes' = 'build';

    setBuildMode() {
        this.mode = 'build';
        this.getBuildStatus();
    }

    setChangesMode() {
        this.mode = 'changes';
        this.getUncomittedChanges();
    }

    get canPublishChanges() {
        return this.uncomittedChanges.length > 0 && this.buildFinishedSuccessfully && this.hasRunBuild;
    }

    get canResetChanges() {
        return this.uncomittedChanges.length > 0 && this.buildFinished;
    }

    commitChanges() {
        this.$bvModal.show(ModalConstants.CommitChangesWindow);
    }

    async resetChanges() {
	    const check = await this.$bvModal.msgBoxConfirm('Are you sure you wish to remove all your changes?', {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

        const result = await GitAPI.ResetChanges();
        this.$bvToast.toast(result.data, {
            variant: 'success',
            title: 'Success',
            solid: true
        });

        this.reset(true);
    }

    async startBuild() {
        if (this.buildInitiating) return;

        this.buildStatusProcess = '';
        this.buildStatusPercent = 0;
        this.buildFinishedSuccessfully = false;
        this.progressBarStatus = '';
        this.mode = 'build';

        this.buildInitiating = true;
        this.buildFinished = false;

        try {
            const result = await RealmApi.InitiateBuild();
            if (result.data) {
                this.$bvToast.toast('Build started successfully', {
                    variant: 'success',
                    title: 'Success',
                    solid: true
                });
                await this.getBuildStatus();
            } else {
                this.$bvToast.toast('A build is already in progress', {
                    variant: 'danger',
                    title: 'Error',
                    solid: true
                });
            }
        } finally {
            this.buildInitiating = false;
            this.hasRunBuild = true;
        }
    }

    buildStatusFetching: boolean = false;

    async getBuildStatus() {
        if (this.buildStatusFetching) return;

        this.buildStatusFetching = true;

        try {
            const result = await RealmApi.GetBuildStatus();

            if (this.buildStatusProcess.length !== result.status.length) {
                this.scrollToBottom();
            }

            this.buildStatusProcess = result.status;
            this.buildStatusPercent = result.percent;
            this.buildFinished = result.finished;
            this.buildFinishedSuccessfully = result.finishedSuccessfully;
            this.progressBarStatus = result.progressBarStatus;
        } finally {
            this.buildStatusFetching = false;
        }
    }

    async getUncomittedChanges() {
        const result = await GitAPI.GetUncommitedChanges();
        this.uncomittedChanges = result.data;
    }

    scrollToBottom(quick: boolean = false) {
	    setTimeout(() => {
	        const statusBoard = this.$refs.statusBoard;
            if (!statusBoard) return;

            statusBoard.scrollTo({
                top: statusBoard.scrollHeight - statusBoard.clientHeight,
                behavior: quick ? 'auto' : 'smooth'
            });
	    }, 25);
    }

    public $refs!: {
		statusBoard: HTMLElement;
	};

    init() {
        this.getBuildStatus();
        this.getUncomittedChanges();

        if (!this.interval) {
            this.interval = setInterval(() => this.getBuildStatus(), 2000);
        }
    }

    reset(soft?: boolean) {
        this.buildFinished = false;
        this.buildStatusProcess = '';
        this.buildStatusPercent = 0;
        this.buildFinishedSuccessfully = false;
        this.progressBarStatus = '';
        this.uncomittedChanges = '';
        this.hasRunBuild = false;
        this.mode = 'build';

        if (!soft) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }
}
